import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const SignOut = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  // Call logout immediately when component mounts
  useEffect(() => {
    // Preserve user data in localStorage before logout
    // Auth0 logout might clear some data, so we backup important data
    try {
      const collegeList = localStorage.getItem('myCollegeList');
      const activities = localStorage.getItem('collegeActivities');
      const academicProfile = localStorage.getItem('academicProfile');
      
      // Create backup with timestamp
      const backup = {
        collegeList: collegeList ? JSON.parse(collegeList) : [],
        activities: activities ? JSON.parse(activities) : [],
        academicProfile: academicProfile ? JSON.parse(academicProfile) : null,
        backupTimestamp: new Date().toISOString()
      };
      
      // Save backup to a persistent key
      localStorage.setItem('quila_data_backup', JSON.stringify(backup));
      console.log('[SignOut] User data backed up before logout');
    } catch (error) {
      console.error('[SignOut] Error backing up data:', error);
    }
    
    // Logout with returnTo to preserve localStorage
    logout({
      logoutParams: {
        returnTo: window.location.origin,
        // Don't clear cache - preserve localStorage
      }
    });
  }, [logout]); // Include logout in dependencies

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Signing you out...</h2>
      <p>Redirecting to Quila homepage...</p>
      <div className="spinner" />
    </div>
  );
};

export default SignOut; 







